module.exports = __webpack_public_path__ + "static/media/1.7.8070e4e5.png";